import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterParams } from "../../types/types";
import { updateUrlWithFilters } from "../../utils/urlParams";

const initialState: FilterParams = {
  countOnPage: 100,
  page: "1",
  product: "all",
  q: "",
  sort: 0, // Изменено с 1 на 0
  city: 0,
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<FilterParams>>) => {
      const newState = { ...state, ...action.payload };
      updateUrlWithFilters(newState);
      return newState;
    },
    setPage: (state, action: PayloadAction<string>) => {
      state.page = action.payload;
      updateUrlWithFilters(state);
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.q = action.payload;
      state.page = "1";
      updateUrlWithFilters(state);
    },
    setCountOnPage: (state, action: PayloadAction<number>) => {
      state.countOnPage = action.payload;
      state.page = "1";
      updateUrlWithFilters(state);
    },
    setCity: (state, action: PayloadAction<number>) => {
      state.city = action.payload;
      state.page = "1";
      updateUrlWithFilters(state);
    },
    resetFilters: (state) => {
      const newState = { ...initialState };
      updateUrlWithFilters(newState);
      return newState;
    },
  },
});

export const {
  setFilters,
  setPage,
  setSearch,
  setCountOnPage,
  setCity,
  resetFilters,
} = filtersSlice.actions;
export default filtersSlice.reducer;
